/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function packageProtection() {
  $("body").on("change", "[data-package-protection]", function (e) {
    e.preventDefault();
    if ($(this).is(":checked")) {
      var params = {
        type: "POST",
        url: "/cart/add.js",
        data:
          "quantity=" +
          1 +
          "&properties[package]=true&id=" +
          $(this).attr("data-package-protection"),
        dataType: "json",
        success: function (line_item) {
          console.log("Added product!");
        },
        error: function (XMLHttpRequest, textStatus) {
          alert("Product currently not available!");
        },
      };
      jQuery.ajax(params);
      return false;
    } else {
      var params = {
        type: "POST",
        url: "/cart/change.js",
        data:
          "quantity=" + 0 + "&id=" + $(this).attr("data-package-protection"),
        dataType: "json",
        success: function (line_item) {
          console.log("Removed product!");
        },
        error: function (XMLHttpRequest, textStatus) {
          console.log("Error Occurred!");
        },
      };
      jQuery.ajax(params);
      return false;
    }
  });
}
packageProtection();


// (function () {
//   console.log('hereee')
//   /**
//    * Display-only variant label mappings.
//    *
//    * Shopify's actual option values are never changed here.
//    * Only the customer-facing Length labels are updated.
//    */
//   var lengthLabelMap = {
//     'CC': {
//       '8mm (1000 fans)': '8mm (500 fans)'
//     }
//   };
//   var cartVariantLabelMap = {
//     'CC / 8mm (1000 fans)': 'CC / 8mm (500 fans)'
//   };

//   function getDisplayLabel(curl, length) {
//     if (
//       lengthLabelMap[curl] &&
//       lengthLabelMap[curl][length]
//     ) {
//       return lengthLabelMap[curl][length];
//     }

//     return length;
//   }

//   function updateLengthLabels(productForm, variant) {
//     if (!productForm || !variant) {
//       return;
//     }

//     var curlOption = productForm.querySelector(
//       '.ProductForm__Option[data-option-name="curl"]'
//     );

//     var lengthOption = productForm.querySelector(
//       '.ProductForm__Option[data-option-name="length"]'
//     );

//     if (!curlOption || !lengthOption) {
//       return;
//     }

//     var curlPosition = parseInt(
//       curlOption.getAttribute('data-option-position'),
//       10
//     );

//     var lengthPosition = parseInt(
//       lengthOption.getAttribute('data-option-position'),
//       10
//     );

//     var curl = variant['option' + curlPosition];
//     var selectedLength = variant['option' + lengthPosition];

//     /**
//      * Block/radio selectors.
//      *
//      * Keep input.value untouched and only change its <label>.
//      */
//     lengthOption
//       .querySelectorAll('input[type="radio"]')
//       .forEach(function (input) {
//         var label = lengthOption.querySelector(
//           'label[for="' + input.id + '"]'
//         );

//         if (label) {
//           label.textContent = getDisplayLabel(curl, input.value);
//         }
//       });

//     /**
//      * Update selected value shown on the option trigger,
//      * if this selector mode uses one.
//      */
//     var selectedValue = lengthOption.querySelector(
//       '.ProductForm__SelectedValue'
//     );

//     if (selectedValue) {
//       selectedValue.textContent = getDisplayLabel(
//         curl,
//         selectedLength
//       );
//     }

//     /**
//      * Popover/dropdown values live outside ProductForm__Option,
//      * so find them using the option position.
//      */
//     var productContainer = productForm.closest('[data-section-id]') ||
//       document;

//     productContainer
//       .querySelectorAll(
//         '.Popover__Value[data-option-position="' +
//           lengthPosition +
//           '"]'
//       )
//       .forEach(function (button) {
//         var actualValue = button.getAttribute('data-value');

//         button.textContent = getDisplayLabel(
//           curl,
//           actualValue
//         );
//       });
//   }

//   function updateRebuyCartVariantLabels() {
//     var cartItems = document.querySelector(
//       '[data-rebuy-component="cart-items"]'
//     );

//     if (!cartItems) {
//       return;
//     }

//     cartItems
//       .querySelectorAll('.rebuy-cart__flyout-item-variant-title')
//       .forEach(function (element) {
//         var actualTitle =
//           element.getAttribute('data-original-variant-title') ||
//           element.textContent.trim();

//         // Preserve the original Shopify title.
//         if (!element.hasAttribute('data-original-variant-title')) {
//           element.setAttribute(
//             'data-original-variant-title',
//             actualTitle
//           );
//         }

//         element.textContent =
//           cartVariantLabelMap[actualTitle] || actualTitle;
//       });
//   }

//   function initializeRebuyCartLabels() {
//     var cartItems = document.querySelector(
//       '[data-rebuy-component="cart-items"]'
//     );

//     if (!cartItems) {
//       return;
//     }

//     updateRebuyCartVariantLabels();

//     var observer = new MutationObserver(function () {
//       updateRebuyCartVariantLabels();
//     });

//     observer.observe(cartItems, {
//       childList: true,
//       subtree: true
//     });
//   }

//   /**
//    * Update whenever the theme resolves a new variant.
//    */
//   document.addEventListener('variant:changed', function (event) {
//     console.log('test')
//     var productForm = event.target.querySelector('.ProductForm');

//     if (!productForm) {
//       return;
//     }

//     updateLengthLabels(
//       productForm,
//       event.detail.variant
//     );
//   });

//   /**
//    * Initial page load.
//    */
//   document.addEventListener('DOMContentLoaded', function () {
//     document
//       .querySelectorAll('.ProductForm')
//       .forEach(function (productForm) {
//         var masterSelector = productForm.querySelector(
//           'select[name="id"]'
//         );

//         var productContainer = productForm.closest(
//           '[data-section-id]'
//         );

//         if (!masterSelector || !productContainer) {
//           return;
//         }

//         var productJson = productContainer.querySelector(
//           '[data-product-json]'
//         );

//         if (!productJson) {
//           return;
//         }

//         try {
//           var data = JSON.parse(productJson.textContent);
//           var selectedVariantId = parseInt(
//             masterSelector.value,
//             10
//           );

//           var variant = data.product.variants.find(
//             function (item) {
//               return item.id === selectedVariantId;
//             }
//           );

//           updateLengthLabels(productForm, variant);
//         } catch (error) {
//           console.warn(
//             'Unable to initialize custom variant labels.',
//             error
//           );
//         }
//       });
//   });
// })();

(function () {
  /**
   * Display-only Length label mappings.
   *
   * Add future mappings here only.
   * These do NOT change the actual Shopify variant values.
   */
  // var lengthLabelMap = {
  //   'CC': {
  //     '8mm (1000 fans)': '8mm (500 fans)'
  //   }
  // };

  // function getDisplayLabel(curl, length) {
  //   if (
  //     lengthLabelMap[curl] &&
  //     lengthLabelMap[curl][length]
  //   ) {
  //     return lengthLabelMap[curl][length];
  //   }

  //   return length;
  // }

  function getDisplayName(variantId) {
    // returns "8mm (500 fans)"
  }

  /**
   * ------------------------------------------------------------
   * PRODUCT PAGE
   * ------------------------------------------------------------
   */

  function updateLengthLabels(productForm, variant) {
    var productContainer = productForm.closest('[data-section-id]');

    if (!productContainer) {
      return;
    }

    var productJson = productContainer.querySelector(
      '[data-product-json]'
    );

    if (!productJson) {
      return;
    }

    var data = JSON.parse(productJson.textContent);
    var variants = data.product.variants;
    var displayNames = data.display_names || {};

    var variantsContainer = productForm.querySelector(
      '.ProductForm__Variants'
    );

    if (!variantsContainer) {
      return;
    }

    var curlOption = variantsContainer.querySelector(
      '.ProductForm__Option[data-option-name="curl"]'
    );

    var lengthOption = variantsContainer.querySelector(
      '.ProductForm__Option[data-option-name="length"]'
    );

    if (!curlOption || !lengthOption) {
      return;
    }

    var curlPosition = parseInt(
      curlOption.getAttribute('data-option-position'),
      10
    );

    var lengthPosition = parseInt(
      lengthOption.getAttribute('data-option-position'),
      10
    );

    var curl = variant['option' + curlPosition];

    // // Block/radio selector labels.
    lengthOption
      .querySelectorAll('input[type="radio"]')
      .forEach(function (input) {
        // console.log('Selected variant:', variant);

        // console.log(
        //   variants.map(function(item) {
        //     return {
        //       id: item.id,
        //       option1: item.option1,
        //       option2: item.option2,
        //       option3: item.option3
        //     };
        //   })
        // );
        // console.log({
        //   curlPosition: curlPosition,
        //   lengthPosition: lengthPosition,
        //   curl: curl
        // });

        var matchingVariant = variants.find(function(item) {

          return (
            item['option' + curlPosition] === curl &&
            item['option' + lengthPosition] === input.value
          );

        });

        var label = lengthOption.querySelector(
          'label[for="' + input.id + '"]'
        );

        if (!label) {
          return;
        }

        var displayName = matchingVariant
          ? displayNames[matchingVariant.id]
          : null;

        label.textContent = displayName || input.value;

      });

    // // Selected value for dropdown-style selectors.
    // var selectedValue = lengthOption.querySelector(
    //   '.ProductForm__SelectedValue'
    // );

    // if (selectedValue && selectedLength) {
    //   selectedValue.textContent = getDisplayLabel(
    //     curl,
    //     selectedLength
    //   );
    // }

    // // Popover/dropdown values.
    // document
    //   .querySelectorAll(
    //     '.Popover__Value[data-option-position="' +
    //       lengthPosition +
    //       '"]'
    //   )
    //   .forEach(function (button) {
    //     var actualValue = button.getAttribute('data-value');

    //     button.textContent = getDisplayLabel(
    //       curl,
    //       actualValue
    //     );
    //   });
  }

  // document.addEventListener('variant:changed', function (event) {
  //   var variant = event.detail.variant;

  //   if (!variant) {
  //     return;
  //   }

  //   var variantsContainer = event.target.querySelector(
  //     '.ProductForm__Variants'
  //   );

  //   if (!variantsContainer) {
  //     return;
  //   }

  //   var curlOption = variantsContainer.querySelector(
  //     '.ProductForm__Option[data-option-name="curl"]'
  //   );

  //   var lengthOption = variantsContainer.querySelector(
  //     '.ProductForm__Option[data-option-name="length"]'
  //   );

  //   if (!curlOption || !lengthOption) {
  //     return;
  //   }

  //   var curlPosition = curlOption.getAttribute(
  //     'data-option-position'
  //   );

  //   var lengthPosition = lengthOption.getAttribute(
  //     'data-option-position'
  //   );

  //   updateLengthLabels(
  //     variantsContainer,
  //     variant['option' + curlPosition],
  //     variant['option' + lengthPosition]
  //   );
  // });

  document.addEventListener('variant:changed', function (event) {
    var productForm = event.target.querySelector('.ProductForm');

    if (!productForm) {
      return;
    }

    updateLengthLabels(
      productForm,
      event.detail.variant
    );
  });

  function initializeProductLabels() {
    document
      .querySelectorAll('.ProductForm')
      .forEach(function (productForm) {

        var productContainer = productForm.closest('[data-section-id]');

        if (!productContainer) {
          return;
        }

        var productJson = productContainer.querySelector(
          '[data-product-json]'
        );

        if (!productJson) {
          return;
        }

        var data = JSON.parse(productJson.textContent);

        var selectedVariant = data.product.variants.find(function (variant) {
          return variant.id == data.selected_variant_id;
        });

        if (!selectedVariant) {
          return;
        }
        console.log(data.selected_variant_id);
        console.log(data.product.variants);
        console.log(selectedVariant);
        updateLengthLabels(
          productForm,
          selectedVariant
        );
      });
  }

  /**
   * ------------------------------------------------------------
   * REBUY CART
   * ------------------------------------------------------------
   */

  function updateRebuyCartVariantLabels() {
    var cartItems = document.querySelector(
      '[data-rebuy-component="cart-items"]'
    );

    if (!cartItems) {
      return;
    }

    cartItems
      .querySelectorAll('.rebuy-cart__flyout-item-variant-title')
      .forEach(function (element) {
        var variantTitle = element.textContent.trim();

        var separatorIndex = variantTitle.indexOf(' / ');

        if (separatorIndex === -1) {
          return;
        }

        var curl = variantTitle
          .substring(0, separatorIndex)
          .trim();

        var length = variantTitle
          .substring(separatorIndex + 3)
          .trim();

        var displayLength = getDisplayLabel(
          curl,
          length
        );

        var displayTitle =
          curl + ' / ' + displayLength;

        // Only update when a mapping actually changed the title.
        if (displayTitle !== variantTitle) {
          element.textContent = displayTitle;
        }
    });
  }

  /**
   * Rebuy can create/re-render the flyout asynchronously,
   * so watch for its cart-items component to appear/change.
   */
  function initializeRebuyCartLabels() {
    var observedCartItems = null;
    var cartItemsObserver = null;

    function attachCartItemsObserver() {
      var cartItems = document.querySelector(
        '[data-rebuy-component="cart-items"]'
      );

      // Already observing this instance.
      if (cartItems && cartItems === observedCartItems) {
        return;
      }

      // Rebuy may replace the entire cart-items element.
      if (cartItemsObserver) {
        cartItemsObserver.disconnect();
        cartItemsObserver = null;
      }

      observedCartItems = cartItems;

      if (!cartItems) {
        return;
      }

      updateRebuyCartVariantLabels();

      cartItemsObserver = new MutationObserver(function () {
        updateRebuyCartVariantLabels();
      });

      cartItemsObserver.observe(cartItems, {
        childList: true,
        subtree: true
      });
    }

    // Check immediately in case Rebuy is already rendered.
    attachCartItemsObserver();

    /**
     * Watch for Rebuy inserting/replacing its cart-items
     * component.
     */
    var rebuyObserver = new MutationObserver(function () {
      attachCartItemsObserver();
    });

    rebuyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * ------------------------------------------------------------
   * INITIALIZATION
   * ------------------------------------------------------------
   */

  function initializeVariantLabels() {
    initializeProductLabels();
    // initializeRebuyCartLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeVariantLabels
    );
  } else {
    initializeVariantLabels();
  }

  document.addEventListener('rebuy:smartcart.show', function () {
    requestAnimationFrame(function () {
      updateRebuyCartVariantLabels();
    });
  });

  document.addEventListener('rebuy:cart.change', function () {
    requestAnimationFrame(function () {
      updateRebuyCartVariantLabels();
    });
  });
})();